import { keyframes } from "@mui/material/styles";

export const STAGGER_MS = 70;

export const cardIn = keyframes`
  from { opacity: 0; transform: translateY(16px) scale(0.97); filter: blur(4px); }
  to   { opacity: 1; transform: none; filter: none; }
`;

export const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

// fill-mode "backwards" (not "both") releases transform after the animation,
// so hover transforms keep working.
export const entranceSx = (delayMs = 0) => ({
  animation: `${cardIn} 0.55s cubic-bezier(0.22, 1, 0.36, 1) backwards`,
  animationDelay: `${delayMs}ms`,
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
});
